import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'enumToArray',
})
export class EnumToArrayPipe implements PipeTransform {
    transform(data: any) {
        try {
            const keys = Object.keys(data).filter((k) => {
                return typeof data[k as any] === 'number';
            });
            return keys.map((key) => {
                return data[key as any];
            });
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            return [];
        }
    }
}
